
import { defineComponent, ref, getCurrentInstance, PropType, computed, onMounted, onUnmounted } from 'vue';
import dayjs from 'dayjs';
import ArticleAction from '../article-action/index.vue';
import { ArticleActionType, ArticleInfo } from '../../models/main';
import { LogType, radarLog, sendLog } from '~/common/radar';
import { copyToClipboard } from '~/common/utils';
export default defineComponent({
  components: {
    ArticleAction,
  },
  props: {
    articleInfo: {
      type: Object as PropType<ArticleInfo>,
      default: () => ({}),
    },
  },
  setup(props, ctx) {
    const { proxy } = getCurrentInstance() as { proxy: any }
    const showNewOpenKwaiNotice = ref(false)
    const showScrollTopIcon = ref(false)
    const articleContainerRef = ref()
    const hasReportedScrollAction = ref(false)

    const handleNewOpenKwaiNotice = (params: Record<string, string>) => {
      proxy.$bus.emit('launchApp')
      sendPopShowLog({
        logType: 'click',
        params: {
          button_type: 'download',
        },
      })
      setTimeout(() => {
        showNewOpenKwaiNotice.value = false
      }, 0)
    }

    const handleNewOpenKwaiNoticeClose = () => {
      showNewOpenKwaiNotice.value = false
      sendPopShowLog({
        logType: 'click',
        params: {
          button_type: 'wait',
        },
      })
    }

    const sendPopShowLog = (logParams: {
      logType: keyof typeof LogType
      params?: Record<string, string>
    }) => {
      const { logType, params } = logParams
      const valueParams: any = {
        ...params,
      }

      sendLog({
        type: logType,
        name: 'PWA_POP',
        value: {
          ...valueParams,
        },
      })
    }

    const handleItemClick = (item: ArticleActionType) => {
      if (item === ArticleActionType.SHARE) {
        const copyUrl = window.location.href
        copyToClipboard(copyUrl)
      } else {
        showNewOpenKwaiNotice.value = true
      }
    }

    const title = computed(() => {
      return props.articleInfo?.title || ''
    })

    const userHeadIcon = computed(() => {
      return props.articleInfo?.headurls?.[0]?.url || ''
    })

    const userName = computed(() => {
      return props.articleInfo?.user_name || ''
    })

    const publishTime = computed(() => {
      if (!props.articleInfo?.publish_timestamp) {
        return ''
      }
      return ` · ${dayjs.unix(props.articleInfo?.publish_timestamp).format(
        'YYYY-MM-DD HH:mm'
      )}`
    })

    const content = computed(() => {
      return props.articleInfo?.content || ''
    })

    onMounted(() => {
      window?.addEventListener('scroll', handleScrollPosition)
    })

    onUnmounted(() => {
      window?.removeEventListener('scroll', handleScrollPosition)
    })

    const handleScrollPosition = () => {
      const scrollTop = window?.scrollY || 0
      showScrollTopIcon.value = scrollTop > 100

      if (!hasReportedScrollAction.value) {
        hasReportedScrollAction.value = true
        radarLog({
          event_type: 'click',
          category: 'KWAI_SHARE',
          src: window.location.pathname,
          name: 'PWA_PC_ARTICLE_SCROLL'
        })
      }
    }

    const handleScrollToTop = () => {
      window?.scrollTo({ behavior: "smooth", top: 0 })
    }

    return {
      userHeadIcon,
      userName,
      publishTime,
      title,
      content,
      handleNewOpenKwaiNotice,
      handleNewOpenKwaiNoticeClose,
      showNewOpenKwaiNotice,
      handleItemClick,
      handleScrollToTop,
      articleContainerRef,
      showScrollTopIcon
    }
  },
})
